import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8fdea702-ef33-49ea-a556-0fc99f37063c/artifacts/zil2jqvm_TFE.creative.agency.png";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <img src={LOGO_URL} alt="Ambe Palace - Best hotel in Dungarpur Rajasthan logo" className="h-12 w-auto" />
              <div>
                <h3 className="text-lg font-bold" style={{ fontFamily: 'Playfair Display, serif' }}>Ambe Palace</h3>
                <p className="text-[10px] text-amber-400 uppercase tracking-wider">Hotel & Restaurant</p>
              </div>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              Comfortable rooms, delicious pure veg dining, and a peaceful stay in the heart of Dungarpur.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-amber-400 mb-5" style={{ fontFamily: 'Playfair Display, serif' }}>Quick Links</h4>
            <nav className="flex flex-col gap-3">
              {[
                { label: "Home", path: "/" },
                { label: "Rooms", path: "/rooms" },
                { label: "Dining Area", path: "/dining" },
                { label: "Restaurant", path: "/restaurant" },
                { label: "Contact", path: "/contact" },
              ].map(item => (
                <Link key={item.path} to={item.path} className="text-sm text-slate-400 hover:text-amber-400 transition-colors duration-200">
                  {item.label}
                </Link>
              ))}
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-amber-400 mb-5" style={{ fontFamily: 'Playfair Display, serif' }}>Contact</h4>
            <div className="flex flex-col gap-4">
              <a href="tel:+916376696360" className="flex items-start gap-3 text-sm text-slate-400 hover:text-amber-400 transition-colors duration-200">
                <Phone className="w-4 h-4 mt-0.5 shrink-0" />
                6376696360
              </a>
              <a href="mailto:contact@ambepalace.com" className="flex items-start gap-3 text-sm text-slate-400 hover:text-amber-400 transition-colors duration-200">
                <Mail className="w-4 h-4 mt-0.5 shrink-0" />
                contact@ambepalace.com
              </a>
              <div className="flex items-start gap-3 text-sm text-slate-400">
                <MapPin className="w-4 h-4 mt-0.5 shrink-0" />
                Dungarpur, Sagwara Road, Tijwaar, Rajasthan 314001
              </div>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-amber-400 mb-5" style={{ fontFamily: 'Playfair Display, serif' }}>Hours</h4>
            <div className="flex flex-col gap-3">
              <div className="flex items-start gap-3 text-sm text-slate-400">
                <Clock className="w-4 h-4 mt-0.5 shrink-0" />
                <div>
                  <p>Reception: <span className="text-white">24/7</span></p>
                  <p>Restaurant: <span className="text-white">10 AM - 12 AM</span></p>
                  <p>Check-in: <span className="text-white">10 AM</span></p>
                  <p>Check-out: <span className="text-white">12 AM</span></p>
                </div>
              </div>
            </div>
            <div className="mt-6">
              <h4 className="text-sm font-bold uppercase tracking-wider text-amber-400 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>Legal</h4>
              <nav className="flex flex-col gap-2">
                <Link to="/privacy-policy" className="text-xs text-slate-500 hover:text-amber-400 transition-colors duration-200">Privacy Policy</Link>
                <Link to="/refund-policy" className="text-xs text-slate-500 hover:text-amber-400 transition-colors duration-200">Refund Policy</Link>
                <Link to="/terms" className="text-xs text-slate-500 hover:text-amber-400 transition-colors duration-200">Terms & Conditions</Link>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-slate-500">&copy; 2026 Hotel Ambe Palace. All rights reserved.</p>
          <p className="text-xs text-slate-500">
            Designed by{" "}
            <a href="https://thefinalexport.com" target="_blank" rel="noopener noreferrer" className="text-amber-400 hover:text-amber-300 transition-colors duration-200 font-semibold">
              The Final Export
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}
